import React from 'react';
import { AttributionText, Link } from '@99designs/emu';
import { FormattedReactMessage } from '@99designs/frontend-components/i18n';

export type DesignerAttributionProps = {
    name: string;
    link: string;
    openInNewTab?: boolean;
};

export function DesignerAttribution({ name, link, openInNewTab }: DesignerAttributionProps) {
    const attributionName = (
        <Link
            href={link}
            target="_blank"
            color={'grey700'}
            fontFamily={'attribution'}
            size="size2"
            openInNewTab={openInNewTab}
        >
            {name}
        </Link>
    );

    return (
        <AttributionText>
            <FormattedReactMessage
                message={__('by <DesignerLink>{designer}</DesignerLink>')}
                values={{ designer: name }}
                replacements={{ DesignerLink: attributionName }}
            />
        </AttributionText>
    );
}
